<template>
  <div class="shop">
    <!-- 开屏广告 弹框 -->
    <!-- <div class="image-container" @touchmove.prevent v-show="showTK">
      <div class="tankuang">
        <img
          :src="this.tkInfo.Thematic"
          alt=""
          @click="gotoUrl1(tkInfo.RIId)"
        />
        <img
          class="close"
          @click="closeTK"
          src="http://alycommunity.anluoyun.cn/lc-lcxms/2023/9/84367be0-fd8.png"
        />
      </div>
    </div> -->
    <div class="top">
      <img
        src="https://chiness-clothing.oss-cn-beijing.aliyuncs.com/goodsImg/6245.png"
        style="width: 100%; display: block"
      />
      <div class="text">
        <div>
          我的积分
          <span class="sanjiao"></span>
        </div>
        <div style="font-size: 50px">{{ this.integral }}</div>
      </div>
    </div>
    <div class="mid">
      <!-- 搜索 -->
      <van-search
        v-model="search"
        placeholder="请输入商品名称"
        @search="onSearch"
        shape="round"
      ></van-search>
      <div class="searchOn" @click="searchOn">
        <img
          src="https://chiness-clothing.oss-cn-beijing.aliyuncs.com/goodsImg/cf42.png"
          alt=""
          style="height: 12px; display: block"
        />
      </div>
      <div class="list">
        <van-tabs
          @click="onClickOnlyOne"
          color="#FEDE00"
          title-active-color="#333333"
        >
          <van-tab name="all" title="全部"> </van-tab>
          <van-tab
            v-for="item in typeList"
            :key="item.id"
            :name="item.id"
            :title="item.categoryName"
          >
          </van-tab>
        </van-tabs>
        <van-list
          class="vanList"
          v-model="loading"
          offset="10"
          :finished="finished"
          finished-text="没有更多了 ~"
          @load="onLoad"
          :immediate-check="false"
        >
          <!-- :immediate-check="false" -->

          <div class="Box">
            <div
              @click="gotoUrl('/hotels/hotelsXq/' + item.id + '/' + integral)"
              class="li"
              v-for="item in goodLists2"
              :key="item.id"
            >
              <img
                alt=""
                v-if="item.goodsImg != null && item.goodsImg != ''"
                :src="item.goodsImg.split(',')[0]"
              />
              <img
                v-else
                src="http://alycommunity.anluoyun.cn/lc-lcx/2023/6/35e14c95-10b.png"
              />
              <div style="box-sizing: border-box; padding: 2px 7.5px 12px">
                <div class="tit van-multi-ellipsis--l2">
                  {{ item.goodsName }}
                </div>
                <div class="line"></div>
                <div class="price">
                  <img
                    src="https://chiness-clothing.oss-cn-beijing.aliyuncs.com/goodsImg/da7a.png"
                    alt=""
                    style="
                      width: 12px;
                      border-radius: 0;
                      margin-right: 4px;
                      vertical-align: middle;
                    "
                  />
                  <span style="vertical-align: middle">
                    {{ item.integral }}
                  </span>
                  <button class="duihuan">兑换</button>
                </div>
              </div>
            </div>
            <div
              @click="gotoUrl('/hotels/hotelsXq/' + item.id + '/' + integral)"
              class="li"
              v-for="item in goodLists1"
              :key="item.id"
            >
              <img
                alt=""
                v-if="item.goodsImg != null && item.goodsImg != ''"
                :src="item.goodsImg.split(',')[0]"
              />
              <img
                v-else
                src="http://alycommunity.anluoyun.cn/lc-lcx/2023/6/35e14c95-10b.png"
              />
              <div style="box-sizing: border-box; padding: 2px 7.5px 12px">
                <div class="tit van-multi-ellipsis--l2">
                  {{ item.goodsName }}
                </div>
                <div class="line"></div>
                <div class="price">
                  <img
                    src="https://chiness-clothing.oss-cn-beijing.aliyuncs.com/goodsImg/da7a.png"
                    alt=""
                    style="
                      width: 12px;
                      border-radius: 0;
                      margin-right: 4px;
                      vertical-align: middle;
                    "
                  />
                  <span style="vertical-align: middle">
                    {{ item.integral }}
                  </span>
                  <button class="duihuan">兑换</button>
                </div>
              </div>
            </div>
          </div>
          <!-- 更多房源 -->
          <!-- <div style="text-align: center">
            <van-button
              @click="gotoUrl('/hotels/moreRooms/' + Start)"
              class="btn btn1"
              >更多房源</van-button
            >
          </div> -->
        </van-list>
        <!-- <van-button v-if="showBtn" @click="backTop" class="backTop"
          ><img
            src="https://dximg.dexian.ren/lczhsq/top.png"
            style="width: 13px; vertical-align: middle"
            alt=""
        /></van-button> -->
      </div>
    </div>

    <div id="allmap" style="display: none"></div>
    <div class="fixed">
      <button class="bottomBtn" @click="orderList">订单列表</button>
    </div>
  </div>
</template>
<script
  type="text/javascript"
  src="https://api.map.baidu.com/api?v=2.0&ak=Liz5cx8NFb67bi5f97L81wjBufDzl6ew"
></script>
<script>
import { Wx_GetHotelRoomList, listTableCategory } from "@/api/Hotel";
import {
  getOCode,
  setOpenId,
  setUrl,
  setPlatform,
  setIntegral,
  setStoreId,
} from "@/utils/auth";
import { loadBMap } from "./baiduLocation";
export default {
  data() {
    return {
      Coordinate: "",
      list: [], //资讯列表
      listfrom: {
        platformId: this.$route.query.platformId,
        pageNum: 1,
        pageSize: 10,
      }, //查询传参
      search: "", //搜索内容
      hidden: true, //没有更多数据了
      loading: false, //加载
      finished: false, //数据完全加载结束为 true
      typeList: [],
      showBtn: false,
      showTK: true,
      tkInfo: {
        Thematic:
          "https://chiness-clothing.oss-cn-beijing.aliyuncs.com/goodsImg/4035.jpg",
      },
      integral: "",
      goodLists1: [],
      goodLists2: [],
    };
  },
  created() {
    // 获取并保存openid
    if (this.$route.query["openId"]) {
      setOpenId(this.$route.query["openId"]);
    }
    console.log(this.$route);
    this.integral = this.$route.query.integral;
    setUrl(this.$route.query.url);
    setPlatform(this.$route.query.platformId);
    setIntegral(this.$route.query.integral);
    setStoreId(this.$route.query.storeId);
  },
  methods: {
    // 获取弹框广告
    // async getRealInfoPage() {
    //   const res = await WeGetRealInfoPage({ tkId: 56 });
    //   if (res.data.data) {
    //     this.tkInfo = res.data.data[0];
    //     console.log(this.tkInfo);
    //   }
    // },

    // 订单列表
    orderList() {
      this.gotoUrl("/hotels/orderList/1");
    },
    closeTK() {
      this.showTK = false;
    },
    // 保留一位小数
    returnFloat1(value) {
      value = Math.round(parseFloat(value) * 10) / 10;
      if (value.toString().indexOf(".") < 0) {
        value = value.toString() + ".0";
      }
      return value;
    },
    handleScroll() {
      const scrollTop = this.getScroll().top;
      this.scrollTop = scrollTop;
    },
    //获得页面向左、向上卷动的距离
    getScroll() {
      return {
        // left:
        //   window.pageXOffset ||
        //   document.body.scrollLeft ||
        //   document.body.scrollLeft ||
        //   0,
        top:
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop ||
          0,
      };
    },
    backTop() {
      // 开个定时器返回顶部时缓慢优雅一些，是 document.body.scrollTop = 0 的升级版
      const timer = setInterval(() => {
        // 页面顶部卷去高度
        let scrollTop =
          document.body.scrollTop || document.documentElement.scrollTop;
        // 高度控速 = 页面顶部卷去高度正值 / n ===> n 越大，返回越慢
        let ispeed = Math.floor(-scrollTop / 5);
        // 页面顶部卷去高度 + 高度控速 ===> 和不为零，定时器一直开启（不明白的同志可以尝试同时打印 scrollTop 和 ispeed）
        document.body.scrollTop = scrollTop + ispeed;
        // 页面顶部卷去高度 + 高度控速 ===> 和为零返回顶部，清除定时器
        if (scrollTop === 0) {
          clearInterval(timer);
        }
      }, 20);
    },
    showBtnF() {
      let scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;
      if (scrollTop > 100) {
        this.showBtn = true;
      } else {
        this.showBtn = false;
      }
    },
    gotominiProgram() {
      // 百度地图API功能
      var that = this;
      window.initBaiduMapScript = () => {
        that.BMap = window.BMap;
        var map = new window.BMap.Map("allmap");
        var point = new that.BMap.Point(116.331398, 39.897445);
        map.centerAndZoom(point, 18);

        var geolocation = new that.BMap.Geolocation();
        geolocation.getCurrentPosition(
          function (r) {
            if (this.getStatus() == BMAP_STATUS_SUCCESS) {
              console.log(r);
              var mk = new BMap.Marker(r.point);
              map.addOverlay(mk);
              map.panTo(r.point);
              that.Coordinate = [
                { lng: r.point.lng, lat: r.point.lat, of: "inner" },
              ];
              // alert("您的位置：" + r.point.lng + "," + r.point.lat);
            } else {
              // alert("failed" + this.getStatus());
            }
            console.log(JSON.stringify(that.Coordinate), "that.Coordinate");
            this.nameCc = {
              Navigation: "导航",
              Coordinate: JSON.stringify(that.Coordinate),
            };
            if (window.__wxjs_environment === "miniprogram") {
              window.wx.miniProgram.navigateTo({
                url:
                  "../openminip/openminip?name=" + JSON.stringify(this.nameCc),
              });
            } else {
              alert("请在小程序中打开");
            }
          },
          { enableHighAccuracy: true }
        );
      };
      loadBMap("initBaiduMapScript");
      // if (navigator.geolocation) {
      //   var geolocation = new window.BMap.Geolocation();
      //   geolocation.getCurrentPosition(
      //     function (r) {
      //       if (this.getStatus() == BMAP_STATUS_SUCCESS) {
      //         alert("您的位置：" + r.point.lng + "," + r.point.lat);
      //       } else {
      //         alert("failed" + this.getStatus());
      //       }
      //     },
      //     { enableHighAccuracy: true }
      //   );
      // } else {
      //   alert("Geolocation is not supported by this browser.");
      // }
      // return;
      // if (navigator.geolocation) {
      //   navigator.geolocation.getCurrentPosition((res) => {
      //     console.log(res); //这里会返回经纬度，然后还要通过经纬度转换地区名称
      //   });
      // }
      // console.log(details);
      // if (details.Coordinate == "" || details.Coordinate == null) {
      //   Toast.fail("暂无位置信息");
      // }
      // else {
    },
    onClickOnlyOne(name) {
      console.log(name);
      this.listfrom.categoryId = name;
      this.list = [];
      this.listfrom.pageNum = 1;
      this.getList();
    },
    // 搜索
    searchOn() {
      this.list = [];
      this.listfrom.pageNum = 1;
      this.getList(this.search);
    },
    // 跳转
    gotoUrl(path) {
      if (window.__wxjs_environment === "miniprogram") {
        // 页面 不会重新加载
        window.wx.miniProgram.navigateTo({
          url: "../public/gotoJF?path=" + path,
        });
      } else {
        // 页面会 重新加载(如:列表页 查看详情后会返回顶部)
        this.$router.push(path);
      }
    },
    // 跳转
    gotoUrl1(RIId) {
      console.log(RIId);
      if (window.__wxjs_environment === "miniprogram") {
        // 页面 不会重新加载
        window.wx.miniProgram.navigateTo({
          url: "../detail/detail?RIId=" + RIId,
        });
      } else {
        alert("请在小程序中打开");
      }
    },
    // 点击进入商户详情
    detailClick(id) {
      var url = "/shop/detail?Id=" + id;
      this.$router.push(url);
    },
    // 获取字典

    // 获取分页列表
    getList(goodsName) {
      this.listfrom.goodsName = goodsName;
      Wx_GetHotelRoomList(this.listfrom).then((res) => {
        if (res.data.code == 200) {
          // this.list = res.data.data.list;
          // this.finished = true;
          /**第二种 */
          let rows = res.data.data.list; //请求返回当页的列表
          // 加载状态结束
          this.list = this.list.concat(rows);
          this.loading = false;

          if (!res.data.data.hasNextPage) {
            // 加载结束 => 没有下一页
            console.log("结束");
            this.finished = true;
          } else {
            this.finished = false;
          }
          // if (this.list.length >= res.data.data.total) {
          //   console.log(111);
          //   this.finished = true;
          // }
        } else {
          this.finished = true;
        }
        console.log(this.list, "this.list");
        var jiArr = [];
        var ouArr = [];
        for (var i = 0; i < this.list.length; i++) {
          if (i % 2 == 0) {
            ouArr.push(this.list[i]);
          } else {
            jiArr.push(this.list[i]);
          }
        }
        console.log(jiArr, "奇数项");
        console.log(ouArr, "偶数项");
        this.goodLists1 = jiArr;
        this.goodLists2 = ouArr;
        // }
      });
    },
    // 下拉刷新
    onLoad() {
      console.log("到底啦");
      // this.list = [];
      this.listfrom.pageNum = this.listfrom.pageNum + 1;
      this.getList(undefined);
    },
    // 搜索
    onSearch() {
      this.list = [];
      this.listfrom.pageNum = 1;
      this.getList(undefined);
    },
    // 时间格式化
    dataFormat(value) {
      var year = value.substr(0, 4);
      var month = value.substr(5, 2);
      var day = value.substr(8, 2);
      var hour = value.substr(11, 2);
      var min = value.substr(14, 2);
      var second = value.substr(17, 2);
      return (
        year + "-" + month + "-" + day + " " + hour + ":" + min + ":" + second
      );
    },
    // 获取商品分类
    getTypeList() {
      listTableCategory({
        platformId: this.$route.query.platformId,
        pageNum: 1,
        pageSize: 10,
      }).then((res) => {
        this.typeList = res.data.data.list;
      });
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);

    console.log(this.$route.params.name);
    window.addEventListener("scroll", this.showBtnF, true);
    if (getOCode() != undefined) {
      if (JSON.parse(getOCode())) {
        this.listfrom.orgCode = JSON.parse(getOCode()).orgCode;
      } else {
        this.listfrom.orgCode = undefined;
      }
    }
    this.getList(undefined);
    this.getTypeList();
    // this.getRealInfoPage();
  },
};
</script>
<style scoped>
@font-face {
  font-family: "Price";
  src: url(../../assets//font//OPPOSANS-B.TTF);
}
.shop {
  background: #f2f2f2;
  overflow: hidden;
  min-height: 100vh;
}

.top {
  position: relative;
  top: -60px;
}

.text {
  position: absolute;
  top: 64%;
  transform: translateY(-50%);
  left: 20px;
  font-size: 18px;
  font-family: PingFang SC;
  /* font-weight: bold; */
  color: #ffffff;
}

.day {
  position: relative;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #1e1e1e;
  display: flex;
  /* justify-content: space-between; */
  padding-top: 14px;
  align-items: center;
  padding-bottom: 12px;
  border-top: 1px solid #f0f0f0;
  border-bottom: 1px solid #f0f0f0;
}

.mid {
  top: -88px;
  width: 100%;
  position: relative;
  margin: auto;
  background: #f2f2f2;
  border-radius: 16px 16px 0 0;
  box-sizing: border-box;
  padding: 15px 12px;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #1e1e1e;
}
.mid .name {
  font-size: 21px;
  font-weight: 800;
}
.mid .address {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #0f95f7;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.mid .i {
  width: 90px;
  height: 5px;
  background: linear-gradient(to left, rgb(254, 222, 0), rgb(255, 255, 255));
  border-radius: 3px;
  position: relative;
  top: -8px;
}

.btn {
  width: 100%;
  height: 47px;
  background: #fede00;
  border-radius: 23.5px;
  border: 1px solid #fede00;
  font-size: 19px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #1e1e1e;
  margin-top: 6px;
}

.btn1 {
  width: 80%;
  height: 40px;
  font-size: 16px;
  margin-top: 22px;
}

/deep/ .van-calendar__confirm {
  height: 42px;
}
/deep/ .van-calendar__day--start,
/deep/ .van-calendar__day--end {
  color: #1e1e1e;
  background-color: #f8de4b;
}

/deep/ .van-calendar__day--middle::after {
  background-color: #f8de4b;
  opacity: 0.19;
}
/deep/ .van-calendar__day--middle {
  color: #1e1e1e;
}
/deep/ .van-button--danger {
  background: #fede00;
  border: 1px solid #fede00;
  color: #1e1e1e;
}

.list {
  padding-bottom: 26px;
  margin-bottom: 20px;
  width: 100%;
  margin-top: 12px;
  overflow: hidden;
}
/deep/ .van-tab__text {
  z-index: 9;
}
/deep/ .van-tabs__line {
  width: 28px !important;
  height: 8px !important;
  background-image: url(https://chiness-clothing.oss-cn-beijing.aliyuncs.com/goodsImg/6fd8.png);
  background-size: 100% 100%;
  bottom: 26px !important;
  left: 0px !important;
  background-color: #ffffff00 !important;
}

/deep/ .van-tab {
  font-size: 13px;
  color: #666666;
  padding: 0 16px;
  flex: none;
}

/deep/ .van-tab--active {
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: bold;
}

.li {
  width: 100%;
  background: #fff;
  border-radius: 8px;
  margin-bottom: 12px;
  overflow: hidden;
  box-sizing: border-box;
  page-break-inside: avoid;
  clear: both;
  /* display: inline-block; */
  position: relative;
}

.li img {
  border-radius: 8px 8px 0 0;
  width: 100%;
  height: auto;
  object-fit: cover;
}
.tit {
  font-size: 15px;
  font-family: PingFang SC;
  /* font-weight: bold; */
  color: #333333;
  margin-bottom: 8px;
}

.line {
  position: absolute;
  width: 100%;
  height: 1px;
  background: #ececec;
  left: 0;
}

.price {
  font-size: 14px;
  font-family: PingFang SC;
  /* font-weight: bold; */
  color: #c9261a;
  padding-top: 10px;
}

.duihuan {
  float: right;
  background: #f4bf41;
  border-radius: 12px;
  font-size: 11px;
  font-family: PingFang SC;
  /* font-weight: bold; */
  color: #333333;
  border: none;
  padding: 4px 10.5px;
  margin-top: -2px;
}

.backTop {
  position: fixed;
  bottom: 40px;
  right: 17px;
  width: 35px;
  height: 35px;
  background: rgba(255, 255, 255, 0.68);
  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.06);
  border-radius: 50%;
}

/* 旧的 样式 */
.van-card__thumb {
  margin-right: 22px;
  margin-left: 5px;
}

/deep/.van-search__content--round {
  background: white;
}

/deep/.van-search {
  padding: 0;
  background-color: transparent;
}
/deep/ .van-field__left-icon {
  display: none;
}

.sanjiao {
  display: inline-block;
  border-top: transparent solid 4px;
  border-right: transparent solid 4px;
  border-bottom: transparent solid 4px;
  border-left: #fff solid 6px;
  margin-bottom: 0px;
}

/deep/ .van-tabs__nav {
  background: transparent;
}
.van-ellipsis--l2 {
  display: -webkit-box !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  -webkit-line-clamp: 2 !important;
  -webkit-box-orient: vertical !important;
}

.searchOn {
  position: absolute;
  top: 19px;
  right: 16px;
  background: linear-gradient(-89deg, #ff6201, #fec200);
  border-radius: 13px;
  padding: 7px 19px;
}

.Box {
  column-count: 2;
  column-gap: 13px;
  column-width: auto;
  margin-top: 10px;
}

.Box::after {
  content: "";
  width: 45.5%;
  height: 0;
  visibility: hidden;
}

.tankuang {
  position: absolute;
  z-index: 999;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 5%;
}

.tankuang img:first-child {
  width: 86%;
  border-radius: 8px;
}

.image-container::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9;
}

.close {
  width: 30px;
  height: 30px;
  margin-top: 15px;
}

.fixed {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 60px;
  background-color: #fff;
  box-shadow: 0 -2px 10px 0 rgba(0, 0, 0, 0.08);
  z-index: 100;
  text-align: center;
}

.bottomBtn {
  background: #f4bf41;
  border-radius: 22px;
  border: none;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  width: 94%;
  padding: 11.5px 0;
  margin-top: 7.5px;
}
</style>
